import React from 'react';

import Paper from '@material-ui/core/Paper';
import Dialog from '@material-ui/core/Dialog';

import Confirmation from '../../components/Forms/Confirmation';
import useStyles from '../styles';


const ConfirmDeletion = ({_id, isOpen, onClose, onSubmit}) => {

  const classes = useStyles();

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      scroll='body'
    >
      <Paper className={classes.paper}>
        <Confirmation
          message={`Gostaria de apagar ${_id} permanentemente?`}
          {...{onSubmit, onClose}}
        />
      </Paper>
    </Dialog>
  );
};

export default ConfirmDeletion;
